import { render, staticRenderFns } from "./RunningWorkflowStats.vue?vue&type=template&id=328d7342&scoped=true"
import script from "./RunningWorkflowStats.vue?vue&type=script&lang=js"
export * from "./RunningWorkflowStats.vue?vue&type=script&lang=js"
import style0 from "./RunningWorkflowStats.vue?vue&type=style&index=0&id=328d7342&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328d7342",
  null
  
)

export default component.exports